//src/core/api/apiClient.ts
import axios, { AxiosInstance, AxiosResponse, AxiosError } from "axios";

const DEFAULT_TIMEOUT = 30000;
const MAX_RETRIES = 1;

// API Endpoints
export const ENDPOINTS = {
  SEND_CONTACT_FORM: "/save-contact-form",
  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgot-password",
  IS_EMAIL_ALREADY_REGISTERED: "/is-email-already-registered",
  NEWSLETTER_SIGN_UP: "/newsletter-sign-up",
  SEND_REGISTRATION_FORM: "/registration",
  RESET_FORGOTTEN_PASSWORD: "/reset-forgotten-password",
} as const;

// API Client setup
const apiClient: AxiosInstance = axios.create({
  baseURL: "https://x4iemzhvq5.execute-api.us-east-1.amazonaws.com/PROD",
  timeout: DEFAULT_TIMEOUT,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Request interceptor for adding custom headers or authentication tokens
apiClient.interceptors.request.use(
  (config) => {
    // You can add auth tokens here if needed in the future
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for handling common errors
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error: AxiosError) => {
    const originalRequest = error.config;

    // Handle token expiration or other auth issues here if needed

    // Implement retry logic for network errors
    if (
      error.message === "Network Error" &&
      originalRequest &&
      !originalRequest.headers["X-Retry-Count"]
    ) {
      let retryCount = 0;

      if (originalRequest.headers) {
        originalRequest.headers["X-Retry-Count"] = "1";
      }

      if (retryCount < MAX_RETRIES) {
        return apiClient(originalRequest);
      }
    }

    return Promise.reject(error);
  }
);

// Helper functions for the two POST requests
export const sendContactForm = async (
  formData: any
): Promise<AxiosResponse> => {
  return apiClient.post(ENDPOINTS.SEND_CONTACT_FORM, formData);
};

export default apiClient;
